// export {default} from './CoachProfile.connect';
import {SCREEN_NAMES} from '/enum/tealium.enum';
import {withScreenPersistence} from '/util/async-storage';

import CoachProfileConnected from './CoachProfile.connect';

export default withScreenPersistence(
  CoachProfileConnected,
  SCREEN_NAMES.coachProfile,
);
